import axiosHelper from './axiosHelper';

export const containsOnlyNumbers = (str?: string) => {
  console.log('validating number', str);
  if (str) {
    if (/^\d+$/.test(str)) return true;
    else return 'Mobile number must contain only numbers';
  }
  return true;
};

const isValidEmailFormat = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Async email uniqueness validator
export const validateEmail = async (email: string) => {
  console.log('validating email: ' + email);
  if (!email) return true;

  if (!isValidEmailFormat(email)) {
    return 'Invalid email format';
  }

  try {
    const response = await axiosHelper.checkEmail(email);
    console.log(response);

    if (!response.available) {
      return 'A user with the same email already exists';
    }
    const fakeResponse = await axiosHelper.checkFake(email);

    if (fakeResponse.isFake) {
      return 'Blacklisted email provider';
    }
    return true;
    // return true;
  } catch (err) {
    console.log(err);
    return 'Failed to validate email';
  }
};

export const validateUsername = async (username: string) => {
    console.log('validating username: ' + username);
    if (!username) return true;

    try {
      const response = await axiosHelper.checkUsername(username);
      console.log(response);
      if (!response.available) {
        return 'A user with the same username already exists';
      }

      return true;
    } catch (error) {
      console.error('Error validating username:', error);
      return 'Failed to validate username';
    }
  };

